import * as React from 'react'

import { Card, Typography } from '@material-ui/core'
import Swiper, { SwiperInstance } from 'react-id-swiper'

import {
  MeasuredMetric
  // SuitableActivity
} from 'components'

import 'swiper/css/swiper.css'
import './styles.scss'

import IAbilityData from '../../../../data/abitilies/interfaces/IAbilityData'

export type IAbilityKey = string

export interface IAbility {
  key: IAbilityKey
}
interface ISwipers {
  heading: SwiperInstance
  additional: SwiperInstance
}

interface IProps {
  currentKey: IAbilityKey
  redirect?: (_: IAbilityKey) => void
  abilities: IAbilityData[]
  talentMap?: any
  isPlusUser: boolean
  relevantAssessment: number
  goToPlus: () => void
  birhtDate: number
}

class AbilityInfo extends React.Component<IProps> {
  params = {
    on: {
      slideChange: () => {
        if (
          this.props.redirect &&
          this.swipers.heading &&
          this.props.abilities[this.swipers.heading.activeIndex - 1]
        ) {
          this.props.redirect(
            this.props.abilities[this.swipers.heading.activeIndex - 1].key
          )
        }
        // uses - 1 because swiper loop uses increment indexes
      }
    }
  }

  styleParams = {
    spaceBetween: 15,
    loop: true
  }
  private swipers: ISwipers = {
    heading: null,
    additional: null
  }

  // tslint:disable-next-line: member-ordering
  initialSlide = () => {
    const { currentKey, abilities } = this.props
    const currentIndex = abilities.findIndex(a => a.key === currentKey)
    return {
      initialSlide: currentIndex
    }
  }

  renderNav = () => {
    const { redirect, currentKey, abilities } = this.props

    return (
      <nav className="abilities-nav">
        {abilities.map(o => (
          <div
            key={o.key}
            className={'dot link' + (currentKey === o.key ? ' active' : '')}
            onClick={() => redirect && redirect(o.key)}
          />
        ))}
      </nav>
    )
  }

  renderHeading = () =>
    this.props.abilities.map(a => (
      <div key={a.key}>
        <Typography className="ability-title">{a.label}</Typography>
        {a.description && (
          <Typography className="ability-description">
            {a.description}
          </Typography>
        )}
      </div>
    ))

  renderAdditional = () => {
    const {
      abilities,
      talentMap,
      isPlusUser,
      goToPlus,
      relevantAssessment,
      birhtDate
    } = this.props
    return abilities.map(a => (
      <div key={a.key}>
        <div className="additional-info-elem">
          <Typography className="measurements-title">
            <span>Measurements:</span>
          </Typography>
          <ul
            className={
              'measured-metrics elem-data' +
              (a.metrics.length > 0 ? ' not-empty' : ' empty')
            }
          >
            {a.metrics.map((m, i) => (
              <MeasuredMetric
                relevantAssessment={relevantAssessment}
                birhtDate={birhtDate}
                talentMap={talentMap}
                metric={m}
                key={i}
                isPlusUser={isPlusUser}
                goToPlus={goToPlus}
              />
            ))}
          </ul>
        </div>
        {/* temporary hidden */}
        {/* <div className="additional-info-elem">
          <Typography className="title">Suitable Activities:</Typography>
          <ul
            className={
              'suitable-activities elem-data elem-data-row' +
              (a.suitableActivities.length > 0 ? ' not-empty' : ' empty')
            }
          >
            {a.suitableActivities.map((a, i) => (
              <SuitableActivity activity={a} key={i} />
            ))}
          </ul>
        </div> */}

        {/* temporary hidden */}
        {/* <div className="additional-info-elem">
          <Typography className="title">Relevant Specialists:</Typography>
          <ul
            className={
              'relevalt-specialists elem-data' +
              (a.relevantSpecialists.length > 0 ? ' not-empty' : ' empty')
            }
          >
            {a.relevantSpecialists.map((s, i) => (
              <SpecCategory specCatg={s} key={i} />
            ))}
          </ul>
        </div> */}
      </div>
    ))
  }

  getHeadingSwiper = (name: keyof ISwipers) => (swiper: SwiperInstance) => {
    this.swipers[name] = swiper
    this.setState({})
  }

  updateSwipers = (mount: boolean = false) => {
    const { abilities } = this.props

    if (this.swipers.heading && this.swipers.additional) {
      if (
        this.swipers.heading.controller &&
        this.swipers.additional.controller
      ) {
        this.swipers.heading.controller.control = this.swipers.additional
        this.swipers.additional.controller.control = this.swipers.heading
      }
    }
    if (!mount) {
      const currentIndex =
        abilities.findIndex(a => a.key === this.props.currentKey) + 1

      if (currentIndex !== this.swipers.heading.activeIndex) {
        this.swipers.heading.slideTo(currentIndex)
      }
      // uses + 1 because swiper loop uses increment indexes
    }
  }

  componentDidMount() {
    this.updateSwipers(true)
  }

  componentDidUpdate(prevProps: IProps) {
    this.updateSwipers()
  }

  render() {
    return (
      <div className="ability-info mobile-container design-fixes">
        <div className="ability-info-heading-container">
          <div className="ability-info-heading">
            <Swiper
              {...this.params}
              {...this.initialSlide()}
              {...this.styleParams}
              getSwiper={this.getHeadingSwiper('heading')}
            >
              {this.renderHeading()}
            </Swiper>
          </div>
        </div>
        {this.renderNav()}
        <div className="additional-info-container">
          <Card className="additional-info">
            <Swiper
              {...this.initialSlide()}
              {...this.styleParams}
              getSwiper={this.getHeadingSwiper('additional')}
            >
              {this.renderAdditional()}
            </Swiper>
          </Card>
        </div>
      </div>
    )
  }
}

export default AbilityInfo



// WEBPACK FOOTER //
// ./src/pages/PatientDetails/Abilities/AbilityInfo/index.tsx